/* eslint-disable no-lone-blocks */
/* eslint-disable indent */
import React from "react";
import PropTypes from "prop-types";

import {
  isWeekend
  // TimeStampIntoHours
} from "../../../constant/helper/helper";
import {
  CREATED_AS_COLOR,
  CREATED_AS_STATUS
  // CREATED_AS_TYPE
} from "../../../constant/constant";

const ShowDateList = ({ dayList, values }) => {
  return dayList.map((dateValue, dateIndex) => {
    const weekendOrNot = isWeekend(dateValue.Date);

    return (
      <td
        key={dateIndex}
        className={
          weekendOrNot
            ? "table-action text-center bg-danger-lighten"
            : "table-action text-center"
        }
      >
        <span className={CREATED_AS_COLOR[dateValue.createdAs]}>
          {CREATED_AS_STATUS[dateValue.createdAs]}
        </span>
        <br />
        <span className={CREATED_AS_COLOR[dateValue.createdAs]}>
          {dateValue.inTime}
        </span>
        -
        <span className={CREATED_AS_COLOR[dateValue.createdAs]}>
          {dateValue.outTime}
        </span>
        <br />
        {values.dataType === "LATE_COMING" ? (
          <span className={CREATED_AS_COLOR[dateValue.createdAs]}>
            {dateValue?.lateTime}
          </span>
        ) : values.dataType === "EARLY_OUT" ? (
          <span className={CREATED_AS_COLOR[dateValue.createdAs]}>
            {dateValue?.earlyOutTime}
          </span>
        ) : values.dataType === "OVER_TIME" ? (
          <span className={CREATED_AS_COLOR[dateValue.createdAs]}>
            {dateValue?.overTime}
          </span>
        ) : (
          <span className={CREATED_AS_COLOR[dateValue.createdAs]}>
            {dateValue?.duration}
          </span>
        )}
      </td>
    );
  });
};

ShowDateList.propTypes = {
  dayList: PropTypes.array.isRequired,
  values: PropTypes.object.isRequired
};

export default ShowDateList;
